export default __webpack_public_path__ + "locales/si/VersionHistory.json?hash=0c15e448b7f568a9a3c15ccf6ba1dc33";